import React, { useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../components/Header';
import Banner from '../components/Banner';
import TrustRow from '../components/TrustRow';
import Categorys from '../components/Categorys';
import ProductCarousel from '../components/products/ProductCarousel';
import { PromoBanner, Brands, GiftCard, Editorial, Newsletter } from '../components/home/Sections';
import { Container } from '../components/home/ui';
import Footer from '../components/Footer';
import { get_products } from '../store/reducers/homeReducer';
import { messageClear } from '../store/reducers/cardReducer';

// Especie de un producto a partir de su categoría y nombre (pestañas de "Recién llegados").
const species = (p) => {
    const s = `${p.category || ''} ${p.name || ''}`.toLowerCase();
    if (/\b(perr|cachorr|canin)/.test(s)) return 'perro';
    if (/\b(gat|felin)/.test(s)) return 'gato';
    return 'otro';
};

const Home = () => {
    const dispatch = useDispatch();
    const { products, latest_product, topRated_product, discount_product } = useSelector(state => state.home);
    const { errorMessage, successMessage } = useSelector(state => state.card);

    useEffect(() => {
        dispatch(get_products());
    }, []);

    // Mensajes de carrito/favoritos de las tarjetas: se muestran una sola vez aquí.
    useEffect(() => {
        if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
        if (errorMessage) { toast.error(errorMessage); dispatch(messageClear()); }
    }, [successMessage, errorMessage]);

    const { newTabs, dealTabs } = useMemo(() => {
        const latestIds = new Set(latest_product.map(p => p._id));
        const topIds = new Set(topRated_product.filter(p => p.rating > 0).slice(0, 3).map(p => p._id));
        const tags = (p) => [latestIds.has(p._id) && 'new', topIds.has(p._id) && 'top'].filter(Boolean);
        const topTags = (p) => (topIds.has(p._id) ? ['top'] : []);

        const recent = products.slice(0, 15);
        const bestPrice = discount_product.length
            ? [...discount_product].sort((a, b) => b.discount - a.discount)
            : [...products].sort((a, b) => a.price - b.price).slice(0, 10);
        const lowStock = products
            .filter(p => !p.bajo_pedido && p.stock > 0 && p.stock <= 5)
            .sort((a, b) => a.stock - b.stock)
            .slice(0, 10);

        return {
            newTabs: [
                { label: 'Todos', items: recent, tags },
                { label: 'Perros', items: recent.filter(p => species(p) === 'perro'), tags },
                { label: 'Gatos', items: recent.filter(p => species(p) === 'gato'), tags },
                { label: 'Otros', items: recent.filter(p => species(p) === 'otro'), tags },
            ],
            dealTabs: [
                { label: 'Mejor valorados', items: topRated_product, tags: topTags },
                { label: 'Mejor precio', items: bestPrice, tags: topTags },
                { label: 'Últimos en stock', items: lowStock, tags: topTags },
            ],
        };
    }, [products, latest_product, topRated_product, discount_product]);

    return (
        <div className='w-full bg-white'>
            <Header />
            <Banner />
            <TrustRow />
            <Categorys />

            {products.length > 0 && (
                <section className='pt-6 pb-12'>
                    <Container>
                        <ProductCarousel title='Recién llegados a la tienda' tabs={newTabs} />
                    </Container>
                </section>
            )}

            <PromoBanner />

            {products.length > 0 && (
                <section className='py-12'>
                    <Container>
                        <ProductCarousel title='Ofertas que te van a encantar' tabs={dealTabs} />
                    </Container>
                </section>
            )}

            <Brands products={products} />
            <GiftCard />
            <Editorial />
            <Newsletter />
            <Footer />
        </div>
    );
};

export default Home;
